import { PlayerData } from "../PlayerData";

export class TargetData {
  constructor(group, players, joId, joType) {
    this.group = group;
    this.players = players;
    this.joId = joId || 0; // 같은 시각 두 조 중 먼저 만든 조가 먼저 발시
    this.joType = joType || ""; // 경기 단계: PRE(예선), 16-30(30m 16강) …
  }

  static fromJson(json) {
    const players = (json.players || []).map((playerJson) =>
      PlayerData.fromJson(playerJson)
    );

    return new TargetData(json.group, players, json.jo_id, json.jo_type);
  }
}
